



































import { Prop, Vue, Component } from 'vue-property-decorator';
import { mdbBtn, mdbCard, mdbCardBody, mdbCardTitle, mdbTooltip } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbBtn,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbTooltip
    }
})
export default class BusinessFrontPageTitlesAndImage extends Vue {
    @Prop(String) private claim!: string;
    @Prop(String) private subclaim!: string;
    @Prop(String) private mainImageUrl!: string;
    @Prop(String) private businessName!: string;
    @Prop(Number) private businessId!: number;
    @Prop(Boolean) private canWrite!: boolean;
}
